import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityFR extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Déclaration d’accessibilité - CamAPS FX</title>
                    <meta name="title" content="Déclaration d’accessibilité"/>
                    <meta name="description"
                          content="CamDiab s’engage à faciliter et à améliorer l’accessibilité et la facilité d’utilisation de ses produits numériques pour tous, y compris les personnes en situat"/>
                    <meta property="og:locale" content="fr_CH"/>
                    <meta name="keywords" content="déclaration d’accessibilité"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Déclaration d’accessibilité</h1>
                                <h3>Version datée du 11 septembre 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab s’engage à faciliter et à améliorer l’accessibilité et la facilité d’utilisation de ses produits numériques pour tous, y compris les personnes en situation de handicap.
                                </p>
                                <h2>
                                    État de conformité
                                </h2>
                                <p>
                                    CamDiab vise à se conformer aux Règles pour l’accessibilité des contenus Web (WCAG), version 2.2, niveau AA (WCAG 2.2 AA). Ces recommandations reconnues dans le monde entier contribuent à rendre les contenus Web plus accessibles à tous.
                                </p>
                                <h2>
                                    Mesures supplémentaires en faveur de l’accessibilité
                                </h2>
                                <p>
                                    CamDiab prend notamment les mesures supplémentaires suivantes afin de faciliter l’utilisation de nos contenus numériques :
                                </p>
                                <ul>
                                    <li>Assurer une formation continue de notre personnel à l’accessibilité</li>
                                    <li>Utiliser des méthodes formelles d’assurance qualité en matière d’accessibilité par le biais d’évaluations réalisées par des tiers</li>
                                    <li>Définir des objectifs et des responsabilités clairs en matière d’accessibilité</li>
                                </ul>
                                <h2>
                                    Commentaires
                                </h2>
                                <p>
                                    Nous accueillons avec intérêt vos commentaires sur la manière dont nous pouvons améliorer nos produits numériques pour les utilisateurs en situation de handicap. Si vous éprouvez des difficultés à consulter ou à parcourir nos contenus, ou si vous remarquez un contenu, une fonctionnalité ou une fonction qui, selon vous, n’est pas entièrement accessible aux personnes en situation de handicap, veuillez nous contacter à l’adresse e-mail de notre service d’assistance : <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Nous prenons vos commentaires au sérieux et les prendrons en considération lorsque nous évaluerons les moyens de répondre aux besoins de tous nos clients ainsi que nos politiques générales en matière d’accessibilité. Par ailleurs, bien que nous ne contrôlions pas les contenus fournis par des prestataires tiers, nous les encourageons vivement à fournir des contenus accessibles et conviviaux.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
